import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import SectionContainer from '../Container';
import CtaTextLink from '../CtaTextLink';

export const BreadcrumbWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  position: relative;
  height: 100%;
  padding: 2rem 0 2.5rem;

  @media (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 2rem 0 3.75rem;
  }
`;

export const BreadcrumbContainer = styled(SectionContainer)`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  position: relative;

  p {
    margin: 0;
    font-size: 1rem;
    position: relative;
    top: 0.1rem;
    font-weight: ${themeGet('fontWeights.medium')};

    @media (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 0.75rem;
      top: -0.15rem;
    }

    @media (max-width: ${themeGet('breakpoints.xxs')}) {
      display: none;
    }
  }
`;

export const BreadcrumbLink = styled(CtaTextLink)`
  padding-right: 4rem;
  margin: 0;
  font-size: 1rem;
  text-decoration: none;
  color: ${({ themes }) =>
    themes === 'dark'
      ? themeGet('colors.white')
      : themeGet('colors.grey-dark')};

  &:hover,
  &:focus {
    text-decoration: underline;
    color: ${themeGet('colors.phoenix-red-hover')};
  }

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding-right: 1.6rem;
    font-size: 0.75rem;
  }

  &:after {
    content: '';
    display: inline-block;
    border-right: 2px solid ${themeGet('colors.divider-grey-light')};
    border-bottom: 2px solid ${themeGet('colors.divider-grey-light')};
    width: 10px;
    height: 10px;
    transform: rotate(-45deg);
    position: absolute;
    top: 38%;
    right: 1.75rem;

    @media (max-width: ${themeGet('breakpoints.md')}) {
      width: 8px;
      height: 8px;
      right: 0.65rem;
      top: 30%;
    }

    @media (max-width: ${themeGet('breakpoints.xxs')}) {
      display: none;
      content: none;
    }
  }

  svg {
    display: none;
  }
`;
